import { ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { HackerSponsorsAnthropic } from '@/types';

// /:event_slug/hacker/anthropic and /26-ar/anthropic — the three twins as one page
// (PORTING.md G5). Argentina sets the display face on every heading; Bogotá adds the
// anti-fraud warning.
export default function Anthropic({
  redeemUrl,
  subtitle,
  warning,
  titleFont,
}: HackerSponsorsAnthropic) {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12 md:py-16">
        <div className="mx-auto w-full max-w-4xl space-y-8">
          <div className="text-center">
            <h1
              className={cn(
                'inline-block font-bold text-2xl text-primary sm:text-3xl md:text-4xl',
                titleFont,
              )}
            >
              <span className="bg-primary px-2 py-1 text-background">
                ANTHROPIC
              </span>
            </h1>
            <p
              className={cn(
                'mt-4 text-primary/70 text-sm uppercase tracking-wide',
                titleFont,
              )}
            >
              {subtitle}
            </p>
          </div>

          <div className="border-2 border-primary bg-background/80 p-6 backdrop-blur-sm sm:p-8 md:p-10">
            <div className="space-y-6">
              <div className="border-primary/20 border-b pb-4">
                <h2
                  className={cn(
                    'font-bold text-2xl text-primary sm:text-3xl md:text-4xl',
                    titleFont,
                  )}
                >
                  CRÉDITOS DE CLAUDE
                </h2>
                <p className={cn('mt-2 text-primary/70 text-sm', titleFont)}>
                  Anthropic está apoyando a los hackers con acceso a Claude.
                </p>
              </div>

              {warning && (
                <div className="space-y-3 rounded-md border border-yellow-200 bg-yellow-50 p-4">
                  <p className="font-mono text-sm text-yellow-800">
                    Los códigos son limitados. Sólo uno por hacker.
                  </p>
                  <p className="font-mono text-sm text-yellow-800">
                    Para evitar que el sistema de antifraude de Anthropic bloquee
                    tus créditos, usa una cuenta con cierta antigüedad e
                    historial.
                  </p>
                </div>
              )}

              <div className="border-primary border-l-4 pl-4">
                <h3
                  className={cn(
                    'font-bold text-primary/70 text-sm uppercase',
                    titleFont,
                  )}
                >
                  Link de canje
                </h3>
                <p className="break-all font-mono text-primary text-sm sm:text-base">
                  {redeemUrl}
                </p>
              </div>

              <a
                href={redeemUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={cn(
                  'inline-flex items-center gap-2 border-2 border-primary bg-primary px-6 py-3 font-bold text-background uppercase tracking-wide transition-all hover:bg-background hover:text-primary',
                  titleFont,
                )}
              >
                Canjear crédito
                <ExternalLink className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
